import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IAppOnlyStore } from 'stores/AllStores';
import { ActivitiesGroup } from 'components/activity';

// Styles
const s = require('./OtherActivities.css');

@inject('store')
@observer
export class OtherActivities extends React.Component<IAppOnlyStore, {}> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { leadActivities } = this.props.store;

    return leadActivities.activitiesGroupsOfOtherLeads.length > 0 ? (
      <div>
        {leadActivities.activitiesGroupsOfOtherLeads.map((group) => {
          return (
            <ActivitiesGroup
              key={group.key}
              title={group.title}
              allFinished={group.allFinished}
              activities={group.activities}
              isOnLeadPage={false}
            />
          );
        })}
      </div>
    ) : (
      <p className={s.empty}>No activities available for other leads.</p>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.tsx